export const FILE_EVENTS = {
    DOWNLOAD_FILE_EVENT: 'download-file',
    DELETE_FILE_EVENT: 'delete-file',
    DELETE_LOCAL_FILE_EVENT: 'delete-local-file',
    UPLOAD_FILES_EVENT: 'upload-files'
};
